import { NotificationsDot } from "@/components/common/navigation/notificationsDot";
import useComplianceHubIssueCount from "@/hooks/complianceHub/useComplianceHubIssueCount";

export default function ComplianceHubIssueCounterNotificationDot() {
  const issueCount = useComplianceHubIssueCount();

  return issueCount > 0 && <NotificationsDot count={issueCount} />;
}
